export const data = [
  {
    "Title": "Adventure Bound",
    "Issue #": "FC259",
    "Condition": "G",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 20,
    "": ""
  },
  {
    "Title": "Animal Comics",
    "Issue #": 20,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Gilligans"
  },
  {
    "Title": "Animal Comics",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Gilligans"
  },
  {
    "Title": "Beatles",
    "Issue #": "NN",
    "Condition": "VG",
    "Website Notes": "1964 One Shot",
    "Personal Notes (Not on website)": "",
    "cost": 120,
    "": ""
  },
  {
    "Title": "Beatles",
    "Issue #": "NN",
    "Condition": "FA/G",
    "Website Notes": "1964 One Shot",
    "Personal Notes (Not on website)": "",
    "cost": 20,
    "": "Rich G"
  },
  {
    "Title": "Bullwinkle Mother Moose Nursery Pomes",
    "Issue #": 1962,
    "Condition": "FN/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 15,
    "": ""
  },
  {
    "Title": "Charlie McCarthy",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Dale Evans",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Donald and the Wheel",
    "Issue #": "FC1190",
    "Condition": "VG/F",
    "Website Notes": "Barks Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Donald Duck",
    "Issue #": 54,
    "Condition": "VG/F",
    "Website Notes": "26 Page Barks Story!",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Charlottesville"
  },
  {
    "Title": "Easter With Mother Goose",
    "Issue #": "",
    "Condition": "VG",
    "Website Notes": "Walt Kelly",
    "Personal Notes (Not on website)": "GA",
    "cost": 33,
    "": ""
  },
  {
    "Title": "Four Color",
    "Issue #": 30,
    "Condition": "G/VG",
    "Website Notes": "Bambi's Children",
    "Personal Notes (Not on website)": "GA",
    "cost": 35,
    "": ""
  },
  {
    "Title": "Four Color",
    "Issue #": 50,
    "Condition": "VG",
    "Website Notes": "Fairy Tale Parade",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Gilligans"
  },
  {
    "Title": "Four Color",
    "Issue #": 140,
    "Condition": "VG/F",
    "Website Notes": "Easter With Mother Goose",
    "Personal Notes (Not on website)": "",
    "cost": 20,
    "": "Gilligans"
  },
  {
    "Title": "Four Color",
    "Issue #": 307,
    "Condition": "VG+",
    "Website Notes": "Bugs Bunny",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Gilligans"
  },
  {
    "Title": "Four Color",
    "Issue #": 386,
    "Condition": "FA",
    "Website Notes": "Uncle Scrooge #1",
    "Personal Notes (Not on website)": "",
    "cost": 30,
    "": ""
  },
  {
    "Title": "Four Color",
    "Issue #": 596,
    "Condition": "CGC 7.0",
    "Website Notes": "1st Turok",
    "Personal Notes (Not on website)": "",
    "cost": 680,
    "": ""
  },
  {
    "Title": "Four Color",
    "Issue #": 717,
    "Condition": "FN",
    "Website Notes": "Moby Dick",
    "Personal Notes (Not on website)": "",
    "cost": 21,
    "": ""
  },
  {
    "Title": "Four Color",
    "Issue #": 840,
    "Condition": "VG/F",
    "Website Notes": "Duck Album",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Gilligans"
  },
  {
    "Title": "Henry",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Howdy Doody Fun Book",
    "Issue #": 1951,
    "Condition": "VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "cost": 15,
    "": ""
  },
  {
    "Title": "Laramie",
    "Issue #": "FC 1125 (#1)",
    "Condition": "VG",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Laramie",
    "Issue #": "FC 1223",
    "Condition": "VG/F",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Laramie",
    "Issue #": "FC 1284",
    "Condition": "FN+",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Laramie",
    "Issue #": "4 (1962)",
    "Condition": "FN",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": "FC 970 (#1)",
    "Condition": "VG",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": "FC 1035 (#2)",
    "Condition": "VG/F",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 3,
    "Condition": "FN-",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 4,
    "Condition": "VG/F",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 5,
    "Condition": "FN",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 6,
    "Condition": "F/VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 7,
    "Condition": "VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 8,
    "Condition": "VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 9,
    "Condition": "VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 10,
    "Condition": "VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Lawman",
    "Issue #": 11,
    "Condition": "F/VF",
    "Website Notes": "Photo Cvr",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Leave it to Beaver",
    "Issue #": "FC 999",
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 15,
    "": ""
  },
  {
    "Title": "Little Beaver",
    "Issue #": "FC267",
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Little Beaver",
    "Issue #": "FC529",
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Little Beaver",
    "Issue #": "FC695",
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Little Iodine",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Rapid City"
  },
  {
    "Title": "Little Lulu",
    "Issue #": 165,
    "Condition": "VG",
    "Website Notes": "in Paris (Giant)",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Little Lulu",
    "Issue #": 180,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Lone Ranger",
    "Issue #": 71,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 15,
    "": ""
  },
  {
    "Title": "Lone Ranger",
    "Issue #": 76,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 15,
    "": ""
  },
  {
    "Title": "Lone Ranger",
    "Issue #": "",
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 75,
    "": ""
  },
  {
    "Title": "Looney Tunes",
    "Issue #": 68,
    "Condition": "VG/F",
    "Website Notes": "Baseball Cvr",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 157",
    "Condition": "GD",
    "Website Notes": "MM and the Beanstock",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Green Valley"
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 170",
    "Condition": "GD",
    "Website Notes": "Spooks Island",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Green Valley"
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 181",
    "Condition": "G/VG",
    "Website Notes": "Jungle Magic",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Green Valley"
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 214",
    "Condition": "VG",
    "Website Notes": "Sky Adventure",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": "Green Valley"
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 231",
    "Condition": "VG/F",
    "Website Notes": "Rajah's Treasure",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Green Valley"
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": "FC 296",
    "Condition": "VG",
    "Website Notes": "Private Eye",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Green Valley"
  },
  {
    "Title": "Peanuts",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Pinocchio",
    "Issue #": "FC 92",
    "Condition": "VG-",
    "Website Notes": "Kelly Art",
    "Personal Notes (Not on website)": "",
    "cost": 20,
    "": ""
  },
  {
    "Title": "Ponytail",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Ponytail",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Popular Comics",
    "Issue #": 81,
    "Condition": "FA",
    "Website Notes": "3/4 Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Raggedy Ann + Andy",
    "Issue #": 11,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": "Rapid City"
  },
  {
    "Title": "Ricky Nelson",
    "Issue #": "FC #956",
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Ripleys Believe it or Not True Ghost Stories",
    "Issue #": 1,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 4,
    "": ""
  },
  {
    "Title": "Roy Rogers",
    "Issue #": 38,
    "Condition": "GD+",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Roy Rogers",
    "Issue #": 45,
    "Condition": "VG-",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Roy Rogers",
    "Issue #": 87,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Roy Rogers",
    "Issue #": 93,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Roy Rogers",
    "Issue #": 140,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Sea Hunt",
    "Issue #": "FC 1041",
    "Condition": "G",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Sea Hunt",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Sea Hunt",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 767 (#2)",
    "Condition": "FN",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 767 (#2)",
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 808 (#3)",
    "Condition": "VF",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 826 (#4)",
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 1026",
    "Condition": "FN",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": "FC 1082",
    "Condition": "FN",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": 5,
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Spin and Marty",
    "Issue #": 9,
    "Condition": "FN",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": "",
    "": ""
  },
  {
    "Title": "Sugarfoot",
    "Issue #": "FC #907(#1)",
    "Condition": "VG/F",
    "Website Notes": "Toth Art",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Tarzan",
    "Issue #": 34,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "3-D Dell",
    "Issue #": 1,
    "Condition": "FA",
    "Website Notes": "Rootie Kazootie",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Turok",
    "Issue #": 4,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Turok",
    "Issue #": 57,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 10,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 15,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 18,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 52,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Uncle Scrooge",
    "Issue #": 52,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Untouchables",
    "Issue #": "FC1237 (#1)",
    "Condition": "VG/F",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 20,
    "": ""
  },
  {
    "Title": "Vacation Parade",
    "Issue #": 5,
    "Condition": "GD+",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "",
    "cost": 10,
    "": ""
  },
  {
    "Title": "Walt Disney's Comics & Stories",
    "Issue #": 23,
    "Condition": "G/VG",
    "Website Notes": "White Pages",
    "Personal Notes (Not on website)": "",
    "cost": 30,
    "": "Manassas"
  },
  {
    "Title": "Walt Disney's Donald Duck",
    "Issue #": "FC 308",
    "Condition": "VG/F",
    "Website Notes": "Barks Art",
    "Personal Notes (Not on website)": "GA",
    "cost": 100,
    "": ""
  },
  {
    "Title": "Whirlybirds",
    "Issue #": "FC1216",
    "Condition": "VG",
    "Website Notes": "Photo Cover",
    "Personal Notes (Not on website)": "",
    "cost": 5,
    "": ""
  },
  {
    "Title": "Zorro",
    "Issue #": "FC #617",
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "cost": 55,
    "": ""
  }
]
;